import { Route, Navigate } from 'react-router-dom'
import { AdminLayout } from './pages/AdminLayout'
import { WorkflowListPage } from './pages/WorkflowListPage'
import { OrganizationListPage } from './pages/OrganizationListPage'
import { WorkflowSetupPage } from './pages/WorkflowSetupPage'
import { EmailSettingsPage } from './pages/EmailSettingsPage'
import { ErpSettingsPage } from './pages/ErpSettingsPage'
import { FlowPage } from './pages/FlowPage'

export const adminRoutes = (
  <Route element={<AdminLayout />}>
    <Route index element={<Navigate to="organizations" replace />} />
    <Route path="workflows" element={<WorkflowListPage />} />
    <Route path="workflows/archived" element={<WorkflowListPage archived />} />
    {/* Selecting an organization on the organizations page filters this same
        list (/admin/workflows?organization=<id>) rather than opening a
        separate detail page. */}
    <Route path="organizations" element={<OrganizationListPage />} />
    <Route path="organizations/:organizationId/workflows/:workflowId/setup" element={<WorkflowSetupPage />} />
    <Route
      path="organizations/:organizationId/workflows/:workflowId/setup/email"
      element={<EmailSettingsPage />}
    />
    <Route
      path="organizations/:organizationId/workflows/:workflowId/setup/flow"
      element={<FlowPage />}
    />
    <Route
      path="organizations/:organizationId/workflows/:workflowId/setup/erp"
      element={<ErpSettingsPage />}
    />
  </Route>
)
